import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './ForgotPassword.css';

type Phase = 'loading' | 'success' | 'error';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [phase, setPhase] = useState<Phase>('loading');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!token) {
      setErrorMsg('Brak tokenu weryfikacyjnego w linku.');
      setPhase('error');
      return;
    }

    let cancelled = false;
    const verify = async () => {
      try {
        const r = await fetch(`/api/auth/verify-email?token=${encodeURIComponent(token)}`);
        const data = await r.json();
        if (cancelled) return;

        if (!r.ok) {
          setErrorMsg(data.detail || 'Weryfikacja nie powiodła się.');
          setPhase('error');
          return;
        }

        // Store tokens and redirect
        if (data.access_token) {
          localStorage.setItem('access_token', data.access_token);
          localStorage.setItem('refresh_token', data.refresh_token || '');
        }
        setPhase('success');
        setTimeout(() => { window.location.href = '/'; }, 1500);
      } catch {
        if (!cancelled) {
          setErrorMsg('Błąd połączenia. Spróbuj ponownie.');
          setPhase('error');
        }
      }
    };

    verify();
    return () => { cancelled = true; };
  }, [token]);

  if (phase === 'loading') {
    return (
      <div className="fp-page">
        <div className="fp-card" style={{ alignItems: 'center', textAlign: 'center' }}>
          <div className="fp-logo">
            <span className="logo-10">10</span><span className="logo-drive">drive</span>
            <span className="logo-moto">moto</span>
          </div>
          <div className="spinner" style={{ width: 40, height: 40, borderWidth: 3, margin: '1rem auto' }} />
          <p className="fp-hint">Weryfikacja adresu email...</p>
        </div>
      </div>
    );
  }

  if (phase === 'success') {
    return (
      <div className="fp-page">
        <div className="fp-card">
          <div className="fp-logo">
            <span className="logo-10">10</span><span className="logo-drive">drive</span>
            <span className="logo-moto">moto</span>
          </div>
          <div className="fp-success">
            <div className="fp-icon">✓</div>
            <p>Email zweryfikowany! Trwa przekierowanie...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fp-page">
      <div className="fp-card">
        <div className="fp-logo">
          <span className="logo-10">10</span><span className="logo-drive">drive</span>
          <span className="logo-moto">moto</span>
        </div>
        <h2>Weryfikacja nie powiodła się</h2>
        <p className="fp-hint">{errorMsg}</p>
        <Link to="/login" className="fp-btn" style={{ textDecoration: 'none' }}>
          Przejdź do logowania
        </Link>
      </div>
    </div>
  );
}
